module.exports = __webpack_public_path__ + "static/media/21.637f4f73.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/hairback/21.png
// module id = 659
// module chunks = 0